export enum ProductDetailsTabsEnum {
  PROFIT_AND_LOSS = 'profit_and_loss',
  REPORTS = 'reports',
  ATTACHMENTS = 'attachments',
  DETAILS = 'details',
  BRIEF = 'brief',
  INVESTMENTS = 'investments',
  EXIT_FUND = 'fund_exit',
  VOTING_SESSIONS = 'voting_sessions',
}
